import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { ConfirmDialog, ConfirmDialogData, ConfirmDialogVariant } from '../components/confirm-dialog/confirm-dialog';
import { TypeConfirmDialog, TypeConfirmDialogData } from '../components/type-confirm-dialog/type-confirm-dialog';

export interface ConfirmOptions {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: ConfirmDialogVariant;
}

export interface AlertOptions {
  title: string;
  message: string;
  okText?: string;
  variant?: ConfirmDialogVariant;
}

@Injectable({
  providedIn: 'root',
})
export class DialogCommonService {
  constructor(private dialog: MatDialog) {}

  async confirm(options: ConfirmOptions): Promise<boolean> {
    const ref = this.dialog.open(ConfirmDialog, {
      width: '420px',
      maxWidth: '92vw',
      disableClose: true,
      panelClass: ['confirm-dialog-panel'],
      data: {
        title: options.title,
        message: options.message,
        confirmText: options.confirmText ?? 'Yes',
        cancelText: options.cancelText ?? 'No',
        showCancel: true,
        variant: options.variant ?? 'info',
      } satisfies ConfirmDialogData,
    });
    return !!(await firstValueFrom(ref.afterClosed()));
  }

  async alert(options: AlertOptions): Promise<void> {
    const ref = this.dialog.open(ConfirmDialog, {
      width: '420px',
      maxWidth: '92vw',
      disableClose: true,
      panelClass: ['confirm-dialog-panel'],
      data: {
        title: options.title,
        message: options.message,
        confirmText: options.okText ?? 'OK',
        showCancel: false,
        variant: options.variant ?? 'info',
      } satisfies ConfirmDialogData,
    });
    await firstValueFrom(ref.afterClosed());
  }

  async confirmTyped(options: ConfirmOptions): Promise<boolean> {
    const ref = this.dialog.open(TypeConfirmDialog, {
      width: '460px',
      maxWidth: '92vw',
      disableClose: true,
      panelClass: ['confirm-dialog-panel'],
      data: {
        title: options.title,
        message: options.message,
        confirmText: options.confirmText ?? 'Delete',
        cancelText: options.cancelText ?? 'Cancel',
      } satisfies TypeConfirmDialogData,
    });
    return !!(await firstValueFrom(ref.afterClosed()));
  }
}

